import { Injector, Pipe, PipeTransform } from '@angular/core';
import { IFormRule, FormElementRegistry, ViewRuleRegistry, Farris, FrameContext, IButtonViewRule } from '@farris/devkit';
import { BehaviorSubject } from 'rxjs';
@Pipe({ name: 'buttonVisibility' })
export class ButtonVisibilityPipe implements PipeTransform {
  private subjects: Map<string, BehaviorSubject<any>> = new Map<string, BehaviorSubject<any>>();
  constructor(protected injector: Injector, protected formElementRegistry: FormElementRegistry, private viewRuleRegistry: ViewRuleRegistry, protected frameContext: FrameContext) {
  }
  /**
   * è®¡ç®å·¥å·æ æé®æ¯å¦å¯è§ç¶æ
   * @param value - toolbarItemç¼å·åå¶å½åå¼
   * @param buttonId - å·¥å·æ idï¼éåé¨æé®é¡¹id
   * @param version - version
   */
  transform(value: any, buttonId: string, version: any) {
    if (!this.formElementRegistry || !this.viewRuleRegistry) {
      return value;
    }
    const toolbarItem = this.formElementRegistry.getElementById(buttonId);
    if (toolbarItem) {
      const viewRule = this.viewRuleRegistry.getRuleById(buttonId) as IButtonViewRule;
      if (viewRule) {
        const ruleVisible = viewRule.visibility;
        const elementRule = toolbarItem.rules.find((item: IFormRule) => item.type === Farris.FormRule.RuleType.Visible);
        // è§åè®¾ç½®ä¸ºå¯è§
        if (ruleVisible) {
          if (!elementRule.dynamic) {
            value = true;
          }
        } else {
          value = false;
        }
      }
    }
    return value;
  }
}
